import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { ICityMastDropdown, IClientCompanyDropdown, IStateMastDropdown } from "../../models/IDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVInputMask } from "../../shared/JVInputMask";
import { IClientContactPerson } from "../../models/ClientContactPerson";
import { IBenchConsultant } from "../../models/BenchConsultant";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ECIType } from "../../models/FDropdown";

export interface IBenchSubmission {
    submission_ID?: number,
    consultant_ID?: number,
    consultant_Name?: string,
    contact_Person_ID?: number,
    endClient?: string,
    state?: IStateMastDropdown,
    state_ID?: number,
    state_Name?: string,
    city?: ICityMastDropdown,
    city_ID?: number,
    city_Name?: string,
    rate?: number,
    interviewMode?: string,
    submissionStatus?: string,
    resume?: string,
    submittedDate?: Date,
    contact_Person_EmailID?: string, //scp
    vendor_Company_ID?: number, //scp
    client?: string, //scp
    company?: IClientCompanyDropdown, //scp
    contact_Person_Name?: string, //scp
    phone_No?: string //scp
}

const schema = yup.object({
    consultant_ID: yup.number().min(1, "Consultant is required").required("Consultant is required"),
    contact_Person_EmailID: yup.string().email("Invalid Email").required("Email is required"),
    company: yup.object().shape({
        vendor_Company_ID: yup.number().min(1, "Client Company is required*").required("Client Company is required*"),
        vendor_Company_Name: yup.string().required()
    }),
    contact_Person_Name: yup.string().required("Contact Person Name is required"),
    phone_No: yup.string().required("Phone Number is required"),
    state: yup.object().shape({
        state_ID: yup.number().min(1, "State is required*").required("State is required*"),
        state_Name: yup.string().required()
    }),
    city: yup.object().shape({
        city_ID: yup.number().min(1, "City is required*").required("City is required*"),
        city_Name: yup.string().required()
    }),
    rate: yup.number().required("Rate is required"),
    endClient: yup.string().required("End Client is required"),
    interviewMode: yup.string().required("Interview mode is required"),
    submissionStatus: yup.string().required("Submission status is required"),
    resume: yup.string().required("Resume is required"),
});

interface Iprops {
    singleData: IBenchSubmission
    open: boolean,
    hideDialog: () => void,
    toast: any,
    onHide?: () => void,
    reload?: boolean,
    setReload?: (is: boolean) => void
}

export const Submission = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [consultantsList, setConsultantsList] = useState<Array<IBenchConsultant>>([]);
    const [resumes, setResumes] = useState<Array<IBenchConsultant>>([]);
    const [consultants, setConsultants] = useState<Array<{ consultant_ID: number, consultant_Name: string }>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [cities, setCities] = useState<Array<ICityMastDropdown>>();
    const [states, setStates] = useState<Array<IStateMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<IBenchSubmission>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "consultant_ID" && value.consultant_ID) {
                loadTableData(value.consultant_ID);
                loadh1bResumes(value.consultant_ID);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const loadh1bResumes = async (consultant_ID: number) => {
        const response = await Fetch("Consultant_Bench/resume", "GET", null, `consultant_ID=${consultant_ID}`, props.toast);
        if (response) {
            const data: Array<IBenchConsultant> = await response.json();
            setResumes(data);
        }
    }
    const loadTableData = async (consultant_ID: number) => {
        setLoading(true);
        const response = await Fetch("Consultant_Bench/byId", "GET", null, `consultant_ID=${consultant_ID}`, props.toast);
        if (response) {
            const data: Array<IBenchConsultant> = await response.json();
            setConsultantsList(data);
        }
        setLoading(false);
    }

    const loadConsultants = async () => {
        const response = await Fetch("Consultant_Bench/me", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setConsultants(data);
        }
    };
    const loadCities = async (filter: string | null) => {
        if (control._formValues.state?.state_ID) {
            const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
            if (response) {
                const data: Array<ICityMastDropdown> = await response.json();
                setCities(data);
            }
        } else {
            props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
        }
    }
    const completeMethodCities = (event: { query: string }) => {
        loadCities(event.query);
    }

    const loadStates = async (filter: string | null) => {
        const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IStateMastDropdown> = await response.json();
            setStates(data);
        }
    }
    const completeMethodStates = (event: { query: string }) => {
        loadStates(event.query);
    }

    useEffect(() => {
        loadConsultants();
    }, []);

    useEffect(() => {
        if (props.singleData.consultant_ID) {
            props.singleData.city = {
                city_ID: props.singleData.city_ID,
                city_Name: props.singleData.city_Name
            }
            props.singleData.state = {
                state_ID: props.singleData.state_ID,
                state_Name: props.singleData.state_Name
            }
            props.singleData.company = {
                vendor_Company_ID: props.singleData.vendor_Company_ID,
                vendor_Company_Name: props.singleData.client
            }
            loadTableData(props.singleData.consultant_ID);
            loadh1bResumes(props.singleData.consultant_ID);
        }
        reset(props.singleData);
    }, [props.singleData.submission_ID]);

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }

    const saveToDB = async (body: IBenchSubmission) => {
        setLoading(true);
        const method = props.singleData?.submission_ID ? "PUT" : "POST";
        const message = props.singleData?.submission_ID ? "Updated Successfully" : "Added Successfully";

        const sub_Vendor_Contact_Person_Mast: IBenchSubmission = {
            contact_Person_EmailID: body.contact_Person_EmailID,
            contact_Person_Name: body.contact_Person_Name,
            phone_No: body.phone_No,
            vendor_Company_ID: body.company?.vendor_Company_ID
        }
        const h1B_Submission: IBenchSubmission = {
            submission_ID: body.submission_ID,
            consultant_ID: body.consultant_ID,
            endClient: body.endClient,
            city_ID: body.city?.city_ID,
            rate: body.rate,
            interviewMode: body.interviewMode,
            submissionStatus: body.submissionStatus,
            resume: body.resume
        }
        const benchSubmission = {
            sub_Vendor_Contact_Person_Mast,
            h1B_Submission
        }
        const response = await Fetch("Consultant_Bench/submission", method, method === "POST" ? benchSubmission : h1B_Submission, null, props.toast);

        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            onHide();
            if (props.onHide) props.onHide();
            if (props.setReload) props.setReload(!props.reload);
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        setConsultantsList([]);
        setResumes([]);
        reset();
    }

    function onSubmit(data: IBenchSubmission) {
        saveToDB(data);
    }

    const fillSubVendor = async () => {
        const emailSchema = yup.object().shape({
            email: yup.string().required().email()
        });
        setLoading(true);
        if (control._formValues.contact_Person_EmailID === "") return;
        const email = control._formValues.contact_Person_EmailID;
        if (!(email?.includes("gmail") || email?.includes("outlook")
            || email?.includes("protonmail") || email?.includes("aol")
            || email?.includes("yahoo") || email?.includes("hotmail")
            || email?.includes("rediff"))) {
            const valid = await emailSchema.isValid({
                email: control._formValues.contact_Person_EmailID,
            });
            if (valid) {
                const response = await Fetch("Sub_Vendor_Contact_Person_Mast/email", "GET", null, `email=${control._formValues.contact_Person_EmailID}`, props.toast);
                if (response) {
                    const data: Array<IClientContactPerson> = await response.json();

                    if (data.length > 0) {
                        setValue("contact_Person_EmailID", data[0].contact_Person_EmailID);
                        setValue("contact_Person_Name", data[0].contact_Person_Name);
                        setValue("phone_No", data[0].phone_No);
                        setValue("vendor_Company_ID", data[0].vendor_Company_ID);
                        setValue("company", { vendor_Company_ID: data[0].vendor_Company_ID, vendor_Company_Name: data[0].vendor_Company_Name });
                    } else {
                        setValue("contact_Person_Name", '');
                        setValue("phone_No", undefined);
                        setValue("vendor_Company_ID", undefined);
                        setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
                        props.toast.current.show({ severity: 'info', content: "Client details not available please enter" });
                    }
                }
            }
            else props.toast.current.show({ severity: 'error', content: "Please Enter a Valid Employer Email-ID" });
        } else {
            setValue("contact_Person_Name", '');
            setValue("phone_No", undefined);
            setValue("vendor_Company_ID", undefined);
            setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: '' });
            props.toast.current.show({ severity: 'error', content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
        }
        setLoading(false);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Update My Bench Submission" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown disabled={props.singleData.submission_ID ? true : false} column={2} label="Consultant" required control={control} name="consultant_ID" optionLabel="consultant_Name"
                    optionValue="consultant_ID" options={consultants} placeholder="Select Consultant" error={errors.consultant_ID?.message} />
                <div className="field col-12 md:col-6"></div>

                {consultantsList.length > 0 && <DataTable className="field col-12 md:col-12" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" value={consultantsList} showGridlines
                >
                    <Column field="consultant_Name" header="Consultant Name" />
                    <Column field="job_Titles" header="Job Title" />
                    <Column field="visa_Name" header="Visa" />
                    <Column field="location" header="Location" />
                    <Column field="rate" header="Rate" />
                    <Column field="marketing_Status" header="M. Status" />
                </DataTable>}

                <JVInput disabled={props.singleData.submission_ID ? true : false} required onBlur={fillSubVendor} label="Client Email Id" column={4} control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />
                <JVDropdownInput disabled={props.singleData.submission_ID ? true : false} required label="Company Name" column={4} completeMethod={completeMethodEC} control={control} name="company" error={errors.company?.vendor_Company_ID?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client Company" />
                <JVInput disabled={props.singleData.submission_ID ? true : false} required label="Contact Person" column={4} control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                <JVInputMask disabled={props.singleData.submission_ID ? true : false} required mask="(999) 999-9999" column={4} label="Phone No" control={control} name="phone_No" error={errors.phone_No?.message} />

                <JVInput disabled={props.singleData.submission_ID ? true : false} required column={3} label="End Client" control={control} name="endClient" error={errors.endClient?.message} />
                <JVDropdownInput disabled={props.singleData.submission_ID ? true : false} required column={3} label="State" completeMethod={completeMethodStates} control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
                <JVDropdownInput disabled={props.singleData.submission_ID ? true : false} required column={3} label="City" completeMethod={completeMethodCities} control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />

                <JVInput required label="Rate" column={3} control={control} type="number" name="rate" error={errors.rate?.message} />
                <JVDropdown disabled={props.singleData.submission_ID ? true : false} column={3} label="Interview Mode" required control={control} name="interviewMode" optionLabel="name"
                    optionValue="name" options={ECIType} placeholder="Select Interview Mode" error={errors.interviewMode?.message} />
                <JVDropdown column={3} label="Submission Status" required control={control} name="submissionStatus" optionLabel="name"
                    optionValue="name" options={props.singleData.submission_ID ? [{ name: "Rejected by PV" }, { name: "Submitted to End Client" }, { name: "Rejected by End Client" }, { name: "Screening in Process" }, { name: "Submitted to Prime Vendor" }] : [{ name: "Submitted to Prime Vendor" }]} placeholder="Select Submission Status" error={errors.submissionStatus?.message} />
                <JVDropdown disabled={props.singleData.submission_ID ? true : false} column={2} label="Resume" required control={control} name="resume" optionLabel="resume_Path"
                    optionValue="resume_Path" options={resumes} placeholder="Select Resume" error={errors.resume?.message} />


                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="field col-12 md:col-12">
                    <Button className="field col-12 md:col-6" loading={loading} label="SAVE" type="submit"></Button>
                    <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
